import { z } from "zod";
import apiClient from "../../../shared/api/client";
import type { RomParticipantsResponse, RomsListResponse } from "../types";

const romSchema = z.object({
  id: z.string(),
  deviceId: z.string(),
  label: z.string(),
  type: z.enum(["local", "remote"]),
  status: z.enum(["active", "deleted"]),
  workspaceId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

const participantSchema = z.object({
  id: z.string(),
  romId: z.string(),
  deviceId: z.string(),
  label: z.string(),
  role: z.enum(["host", "guest"]),
  platform: z.string().nullable(),
  joinedAt: z.string(),
  leftAt: z.string().nullable(),
});

const romsListResponseSchema = z.object({
  data: z.array(romSchema),
});

const participantsResponseSchema = z.object({
  data: z.array(participantSchema),
});

export const fetchRoms = async (): Promise<RomsListResponse> => {
  const response = await apiClient.get("/roms");
  return romsListResponseSchema.parse(response.data);
};

export const fetchRomParticipants = async (romId: string): Promise<RomParticipantsResponse> => {
  const response = await apiClient.get(`/roms/${romId}/participants`);
  return participantsResponseSchema.parse(response.data);
};

export const updateRomStatus = async (id: string, status: string): Promise<void> => {
  await apiClient.patch(`/roms/${id}/status`, { status });
};

export const deleteRom = async (id: string): Promise<void> => {
  await updateRomStatus(id, "deleted");
};
